import { Button, Typography } from "@mui/material"
import { TranslationField } from "app/language/components/TranslationField"
import { ITranslation } from "app/language/model"
import { translate } from "app/language/service"
import { deepCopy, deepEquals } from "app/tools/common"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"

interface IUiConfigTranslationProps {
  title: string
  translation: ITranslation
  setTranslation: (translation: ITranslation) => any
}

export const UiConfigTranslation = React.memo(({ title, translation, setTranslation }: IUiConfigTranslationProps) => {
  const [tempTranslations, setTempTranslations] = React.useState(deepCopy(translation))
  const [hasChange, setHasChange] = React.useState(false)
  React.useEffect(() => setTempTranslations(deepCopy(translation)), [translation])
  const setNewTranslation = (newTranslation: ITranslation) => {
    setTempTranslations(newTranslation)
    if (!deepEquals(translation, newTranslation)) {
      if (!hasChange) {
        setHasChange(true)
      }
    } else if (hasChange) {
      setHasChange(false)
    }
  }
  const cancelChanges = () => {
    setTempTranslations(deepCopy(translation))
    setHasChange(false)
  }
  const submitChanges = () => {
    setTranslation(deepCopy(tempTranslations))
    setHasChange(false)
  }
  return (
    <FlexBox vertical ai="start" gap=".5rem" sx={{ mb: "1rem" }}>
      <Typography color="textPrimary" fontSize="1rem" fontWeight="bold">
        {title}
      </Typography>
      <TranslationField
        translation={tempTranslations}
        setTranslation={setNewTranslation}
        sx={{ "& .MuiTextField-root": { width: "25rem" } }}
      />
      {hasChange && (
        <FlexBox fullWidth jc="end" gap wrap>
          <Button variant="outlined" onClick={() => cancelChanges()}>
            {translate("button.cancel")}
          </Button>
          <Button variant="contained" onClick={() => submitChanges()}>
            {translate("button.ok")}
          </Button>
        </FlexBox>
      )}
    </FlexBox>
  )
})
